import { render, staticRenderFns } from "./deleteEnvForm.vue?vue&type=template&id=66d203b7&"
import script from "./deleteEnvForm.vue?vue&type=script&lang=ts&"
export * from "./deleteEnvForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports